export const timeFilterEnum = {
  ALL: 'ALL',
  MINUTE_30: 'MINUTE_30',
  HOURLY: 'HOURLY',
  HOUR_12: 'HOUR_12',
  DAILY: 'DAILY',
} as const

export type TimeFilterEnum = (typeof timeFilterEnum)[keyof typeof timeFilterEnum]

export type TimeFilter = TimeFilterEnum